import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../Environments/Environment";
import { LoginRequest } from "../Dto/LoginRequest";
import { LoginResponse } from "../Dto/LoginResponse";
import { ResetPasswordRequest } from "../Dto/ResetPasswordRequest";
import { ResetPasswordResponse } from "../Dto/ResetPasswordResponse";
import { firstValueFrom } from "rxjs";

/**
 * Thin auth API client scoped to authentication flows.
 * Uses adminServiceUrl from environment to keep backend base configurable per build.
 */
@Injectable({ providedIn: "root" })
export class AuthApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.adminServiceUrl;

  async login(payload: LoginRequest): Promise<LoginResponse> {
    return await firstValueFrom(this.http.post<LoginResponse>(`${this.baseUrl}/auth/login`, payload, { withCredentials: true }));
  }

  async me(): Promise<LoginResponse> {
    return await firstValueFrom(this.http.get<LoginResponse>(`${this.baseUrl}/auth/me`, { withCredentials: true }));
  }

  async logout(): Promise<void> {
    await firstValueFrom(this.http.post(`${this.baseUrl}/auth/logout`, null, { withCredentials: true }));
  }

  async resetPassword(payload: ResetPasswordRequest): Promise<ResetPasswordResponse> {
    return await firstValueFrom(
      this.http.put<ResetPasswordResponse>(`${this.baseUrl}/auth/reset-password`, payload, { withCredentials: true }),
    );
  }

  async refresh(payload: { refreshToken: string }): Promise<LoginResponse> {
    return await firstValueFrom(this.http.post<LoginResponse>(`${this.baseUrl}/auth/refresh`, payload, { withCredentials: true }));
  }
}
